import * as React from 'react'
import Svg, {
  SvgProps,
  Path,
  G,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
  Rect
} from 'react-native-svg'

function CancelRescue(props: SvgProps) {
  return (
    <Svg width={150} height={147} viewBox="0 0 150 147" fill="none" {...props}>
      <G clipPath="url(#clip0_2753_13157)">
        <Path
          d="M71.6482 118.448C99.6482 118.448 122.349 95.7477 122.349 67.6477C122.349 39.5477 99.5482 16.8477 71.6482 16.8477C43.6482 16.8477 20.9482 39.5477 20.9482 67.6477C20.9482 95.7477 43.6482 118.448 71.6482 118.448Z"
          fill="#EAEEF9"
        />
        <Path
          d="M119.049 34.3484C121.313 34.3484 123.149 32.5128 123.149 30.2484C123.149 27.9841 121.313 26.1484 119.049 26.1484C116.784 26.1484 114.949 27.9841 114.949 30.2484C114.949 32.5128 116.784 34.3484 119.049 34.3484Z"
          fill="#EAEEF9"
        />
        <Path
          d="M125.049 18.348C126.595 18.348 127.849 17.0944 127.849 15.548C127.849 14.0016 126.595 12.748 125.049 12.748C123.502 12.748 122.249 14.0016 122.249 15.548C122.249 17.0944 123.502 18.348 125.049 18.348Z"
          fill="#EAEEF9"
        />
        <Path
          d="M23.6486 34.2484C25.195 34.2484 26.4486 32.9948 26.4486 31.4484C26.4486 29.902 25.195 28.6484 23.6486 28.6484C22.1022 28.6484 20.8486 29.902 20.8486 31.4484C20.8486 32.9948 22.1022 34.2484 23.6486 34.2484Z"
          fill="#EAEEF9"
        />
        <Path
          d="M6.54863 88.2477C9.42051 88.2477 11.7486 85.9196 11.7486 83.0477C11.7486 80.1758 9.42051 77.8477 6.54863 77.8477C3.67675 77.8477 1.34863 80.1758 1.34863 83.0477C1.34863 85.9196 3.67675 88.2477 6.54863 88.2477Z"
          fill="#EAEEF9"
        />
        <Path
          d="M148.917 51.6975H143.956V46.7363H139.704V51.6975H134.743V56.0916H139.704V61.0528H143.956V56.0916H148.917V51.6975Z"
          fill="url(#paint0_linear_2753_13157)"
        />
        <Path
          d="M66.8164 4.75081H62.5754V0.509766H58.9402V4.75081H54.6992V8.50717H58.9402V12.7482H62.5754V8.50717H66.8164V4.75081Z"
          fill="url(#paint1_linear_2753_13157)"
        />
        <Path
          d="M16.9017 47.0611H13.2782V43.4375H10.1724V47.0611H6.54883V50.2705H10.1724V53.894H13.2782V50.2705H16.9017V47.0611Z"
          fill="url(#paint2_linear_2753_13157)"
        />
        <G>
          <Path
            d="M107.313 57.8507L97.2994 33.3991C95.514 29.0522 90.8566 26.5682 86.2768 27.5773L60.428 33.1662C58.2545 33.632 56.3915 35.1068 55.3048 37.0474L30.698 83.9323C29.6889 85.8729 30.3875 88.3569 32.4057 89.366L76.9619 112.809C78.9025 113.818 81.3864 113.119 82.3956 111.101L107.002 64.2158C108.089 62.2752 108.167 59.9465 107.313 57.8507ZM82.5508 47.9924C79.3682 46.3623 78.1262 42.4035 79.834 39.2209C81.4641 36.0383 85.4229 34.7963 88.6055 36.5041C91.7881 38.1342 93.03 42.093 91.3223 45.2756C89.6922 48.4582 85.7334 49.7001 82.5508 47.9924Z"
            fill="url(#paint3_linear_2753_13157)"
          />
        </G>
        <Path
          d="M85.7334 42.0159C105.993 31.5366 113.989 15.9342 103.432 9.18094C92.8748 2.42765 82.4732 9.18094 79.834 28.8198"
          stroke="#ADB6C8"
          strokeWidth={5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M80.4464 75.8436C81.817 76.6023 83.6421 76.0779 84.4008 74.7073C85.1595 73.3368 84.635 71.5117 83.2645 70.753C81.8939 69.9943 80.0688 70.5187 79.3101 71.8893C78.4972 73.3577 78.978 75.0307 80.4464 75.8436Z"
          fill="#AAB2C5"
        />
        <Path
          d="M72.6359 79.4252L71.3633 78.7207C71.587 75.775 69.2358 73.3223 66.3338 73.2506C65.236 73.1545 64.0192 73.5041 63.1399 74.1684L61.8672 73.4639C64.6241 71.0252 69.0155 71.4098 71.3021 74.2104C72.3475 75.5565 72.9698 77.4358 72.6359 79.4252Z"
          fill="#AAB2C5"
        />
        <Path
          d="M60.867 65.0058C62.2375 65.7645 64.0626 65.24 64.8213 63.8695C65.58 62.4989 65.0556 60.6738 63.685 59.9151C62.3145 59.1564 60.4894 59.6808 59.7307 61.0514C59.0157 62.574 59.4964 64.247 60.867 65.0058Z"
          fill="#AAB2C5"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_2753_13157"
          x1={141.831}
          y1={47.2336}
          x2={141.831}
          y2={55.2693}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B0BACC" />
          <Stop offset={1} stopColor="#969EAE" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_2753_13157"
          x1={60.7588}
          y1={0.934915}
          x2={60.7588}
          y2={7.80423}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B0BACC" />
          <Stop offset={1} stopColor="#969EAE" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_2753_13157"
          x1={11.7261}
          y1={43.8008}
          x2={11.7261}
          y2={49.6699}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B0BACC" />
          <Stop offset={1} stopColor="#969EAE" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_2753_13157"
          x1={69.0411}
          y1={25.3663}
          x2={69.0411}
          y2={114.193}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FDFEFF" />
          <Stop offset={0.9964} stopColor="#ECF0F5" />
        </LinearGradient>
        <ClipPath id="clip0_2753_13157">
          <Rect width={149} height={146} fill="white" x={0.5} y={0.5} />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CancelRescue
